import { Card } from "react-bootstrap";

export default function KpiStat({ label, value }) {
  return (
    <Card className="shadow-sm h-100">
      <Card.Body className="py-3">
        <div className="text-muted text-uppercase mb-1">{label}</div>
        <div className="fs-2 fw-semibold">{value}</div>
      </Card.Body>
    </Card>
  );
}
